import { type Icon } from "@/components/Base/Lucide/Lucide.vue";
import { type Themes } from "@/stores/theme";
import { defineStore } from "pinia";
import sideMenu from "@/main/side-menu";
import i18n from "@/lang/i18n";

import simpleMenu from "@/main/simple-menu";
import topMenu from "@/main/top-menu";

export interface Menu {
  icon: Icon;
  title: string;
  pageName?: string;
  subMenu?: Menu[];
  ignore?: boolean;
}


export const useMenuStore = defineStore("menu", {
  state: (): MenuState => ({
    menuValue: [],
  }),
  getters: {
    menu: (state) => (layout: Themes["layout"]) => {
        const t = i18n.global.t;
        const sideMenu: Array<Menu | "divider"> = [

            {
                icon: "Home",
                pageName: "home",
                title: t("message.menu.dashboard")

            },
            {
                icon: "Settings",
                pageName: "management",
                title: t("message.menu.management"),
                subMenu: [
                    {
                        icon: "Trello",
                        pageName: "train-classes",
                        title: t("message.menu.trainClasses"),
                    },
                    {
                        icon: "Underline",
                        pageName: "train-lines",
                        title: t("message.menu.trainLines"),
                    },
                    {
                        icon: "WindIcon",
                        pageName: "train-routes",
                        title: t("message.menu.trainRoutes"),
                    },
                    {
                        icon: "Type",
                        pageName: "trains",
                        title: t("message.menu.trains"),
                    },
                    {
                        icon: "TrendingUp",
                        pageName: "stations",
                        title: t("message.menu.stations"),
                    },
                    {
                        icon: "Trello",
                        pageName: "train-prices",
                        title: t("message.menu.prices")
                    },
                    {
                        icon: "Calendar",
                        pageName: "station-schedules",
                        title: t("message.menu.stationSchedules"),
                    },
                    {
                        icon: "Briefcase",
                        pageName: "zones",
                        title: t("message.menu.zones"),
                    },
                ],
            },
            {
                icon: "CalendarIcon",
                pageName: "today-trains",
                title: t("message.menu.todayTrains"),
            },
            {
                icon: "CreditCard",
                pageName: "card-management",
                title: t("message.menu.cardManagement"),
                subMenu: [
                    {
                        icon: "CreditCard",
                        pageName: "cards",
                        title: t("message.menu.cards"),
                    },
                    {
                        icon: "OctagonIcon",
                        pageName: "card-statement",
                        title: t("message.menu.cardStatement"),
                    },
                    {
                        icon: "AlignCenter",
                        pageName: "account-balance-adjustment",
                        title: t("message.menu.balanceAdjustment"),
                    },
                    {
                        icon: "CheckIcon",
                        pageName: "balance-adjustment-approval",
                        title: t("message.menu.adjustmentApproval"),
                    },
                ],
            },
            {
                icon: "UsersIcon",
                pageName: "customers",
                title: t("message.menu.customerManagement"),
                subMenu: [
                    {
                        icon: "UsersRound",
                        pageName: "customers",
                        title: t("message.menu.customers"),
                    },
                    {
                        icon: "UserCheckIcon",
                        pageName: "customer-accounts",
                        title: t("message.menu.customerAccounts"),
                    },
                    {
                        icon: "WindIcon",
                        pageName: "contract-institutions",
                        title: t("message.menu.contractInstitutions"),
                    },
                    {
                        icon: "ZapOffIcon",
                        pageName: "account-packages",
                        title: t("message.menu.accountPackages"),
                    },
                    {
                        icon: "TagIcon",
                        pageName: "employee-incentive",
                        title: t("message.menu.employeeIncentive"),
                    },
                ],
            },
            {
                icon: "TypeIcon",
                pageName: "transactions",
                title: t("message.menu.transactionManagement"),
                subMenu: [
                    {
                        icon: "TrendingUpIcon",
                        pageName: "transactions",
                        title: t("message.menu.transactions"),
                    },
                    {
                        icon: "CheckIcon",
                        pageName: "cancel-transaction-approval",
                        title: t("message.menu.cancelApproval"),
                    },
                    {
                        icon: "StarIcon",
                        pageName: "adjustment-transactions",
                        title: t("message.menu.adjustmentTransactions"),
                    },
                ],
            },
            {
                icon: "MonitorSmartphone",
                pageName: "devices",
                title: t("message.menu.devices"),
            },
            {
                icon: "Zap",
                pageName: "validation_transaction",
                title: t("message.menu.validation"),
            },
            {
                icon: "Activity",
                pageName: "suspicious_transaction",
                title: t("message.menu.suspiciousReport"),
            },
            {
                icon: "Zap",
                pageName: "train_capacity",
                title: t("message.menu.trainCapacity"),
            },
            {
                icon: "FilePlusIcon",
                pageName: "collections",
                title: t("message.menu.collections"),
                subMenu: [
                    {
                        icon: "FilePlusIcon",
                        pageName: "collections",
                        title: t("message.menu.collections"),
                    },
                    {
                        icon: "CheckIcon",
                        pageName: "collection-approval",
                        title: t("message.menu.collectionApproval"),
                    },
                    {
                        icon: "UserCheckIcon",
                        pageName: "operator-accounts",
                        title: t("message.menu.operatorAccounts"),
                    },
                    {
                        icon: "FilePlusIcon",
                        pageName: "m10-summary",
                        title: t("message.menu.m10Summary"),
                    },
                ],
            },
            {
                icon: "LayoutIcon",
                pageName: "cargo",
                title: t("message.menu.cargo"),
                subMenu: [
                    {
                        icon: "UsersIcon",
                        pageName: "cargo-customers",
                        title: t("message.menu.cargoCustomers"),
                    },
                    {
                        icon: "TrendingUpIcon",
                        pageName: "cargo-transactions",
                        title: t("message.menu.cargoTransactions"),
                    },
                    {
                        icon: "ArchiveIcon",
                        pageName: "cargo-configurations",
                        title: t("message.menu.cargoConfigurations"),
                    },
                    {
                        icon: "TrendingUpIcon",
                        pageName: "cargo-prices",
                        title: t("message.menu.cargoPrices"),
                    },
                ],
            },
            {
                icon: "PrinterIcon",
                pageName: "reports",
                title: t("message.menu.reports"),
                subMenu: [
                    {
                        icon: "PrinterIcon",
                        pageName: "module-reports",
                        title: t("message.menu.moduleReports"),
                    },
                ],
            },
            {
                icon: "UserIcon",
                pageName: "users",
                title: t("message.menu.users"),
                subMenu: [
                    {
                        icon: "UsersIcon",
                        pageName: "system-users",
                        title: t("message.menu.systemUsers"),
                    },
                    {
                        icon: "ScissorsIcon",
                        pageName: "manage-roles",
                        title: t("message.menu.rolesPermissions"),
                    },
                ],
            },
            {
                icon: "CalendarIcon",
                pageName: "train-schedules",
                title: t("message.menu.trainSchedules"),
            },
            {
                icon: "AnchorIcon",
                pageName: "setting",
                title: t("message.menu.trainSetup"),
                subMenu: [
                    {
                        icon: "TargetIcon",
                        pageName: "coach-manufactures",
                        title: t("message.menu.coachManufactures"),
                    },
                    {
                        icon: "MapPinIcon",
                        pageName: "coach-layouts",
                        title: t("message.menu.coachLayouts"),
                    },
                    {
                        icon: "Activity",
                        pageName: "coaches",
                        title: t("message.menu.coaches"),
                    },
                    {
                        icon: "MapIcon",
                        pageName: "train-layouts",
                        title: t("message.menu.trainLayouts"),
                    },
                ],
            },
            "divider",
            {
                icon: "SettingsIcon",
                pageName: "setting",
                title: t("message.menu.settings"),
                subMenu: [
                    {
                        icon: "Activity",
                        pageName: "special-group",
                        title: t("message.menu.specialGroup"),
                    },
                    {
                        icon: "Activity",
                        pageName: "incentive",
                        title: t("message.menu.incentiveConfigurations"),
                    },
                    {
                        icon: "Activity",
                        pageName: "app-version",
                        title: "App Versions",
                    },
                ],
            },
            {
                icon: "ExternalLinkIcon",
                pageName: "news-updates",
                title: t("message.menu.newsUpdates")            },
            {
                icon: "ExternalLinkIcon",
                pageName: "cfm-information",
                title: t("message.menu.cfmInformation"),
            },
            {
                icon: "CreditCard",
                pageName: "audit-trails",
                title: t("message.menu.auditTrail"),
            },
            {
                icon: "BookIcon",
                pageName: "device-summary-report",
                title: t("message.menu.deviceSummaryReport"),
            },
        ];
      if (layout == "top-menu") {
        return topMenu;
      }

      if (layout == "simple-menu") {
        return simpleMenu;
      }

      return sideMenu;
    },
  },
});
